export default {"src":"/_next/static/media/regenerate.6fbde919.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};